import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import { Comment } from 'comment';
import { AssistiveTextPreview } from 'components';
import styles from './CardPreview.scss';

const CardPreview = ({
  questionData,
  children,
  commentActions,
  commentsProps,
  handleCancelComment,
  handleOnComment,
  commentIdToUpdate,
  index,
}) =>
  <div
    id={questionData.id}
    className={styles.questionContainer}
    data-testid={`request__question-${questionData.id}`}
  >
    <div className={styles.questionTitleContainer}>
      <Typography
        variant='subtitle2'
        className={styles.questionTitle}
      >
        {index} {questionData.data.label}
        { get(questionData, 'data.isRequired', true) &&
          <span className={styles.requiredAsterisk}> *</span>
        }
      </Typography>
      <div className={styles.actions}>
        {
            get(questionData, 'data.assistiveText.title') &&
            get(questionData, 'data.assistiveText.description') &&
                <AssistiveTextPreview
                    className={styles.assistiveTextIcon}
                    assistiveText={questionData.data.assistiveText}
                />
        }
        <Comment
            actions={commentActions}
            {...commentsProps}
            className={styles.commentIcon}
            commentIdToUpdate={commentIdToUpdate}
            onComment={(comment) => handleOnComment(comment, questionData)}
            onCancel={handleCancelComment}
        />
      </div>
    </div>
    {children}
  </div>

CardPreview.propTypes = {
  questionData: PropTypes.shape({
    data: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      isRequired: PropTypes.bool,
    }).isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
  commentActions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired,
  })),
  commentsProps: PropTypes.shape({
    commentData: PropTypes.shape({
      placeholder: PropTypes.string,
      cancelButtonText: PropTypes.string.isRequired,
      commentButtonText: PropTypes.string.isRequired,
      replyButtonText: PropTypes.string.isRequired,
      updateButtonText: PropTypes.string.isRequired,
      isAdminText: PropTypes.string.isRequired,
      user: PropTypes.string.isRequired,
    }).isRequired,
    comments: PropTypes.array,
  }).isRequired,
  handleCancelComment: PropTypes.func.isRequired,
  handleOnComment: PropTypes.func.isRequired,
  commentIdToUpdate: PropTypes.string,
  index: PropTypes.string,
  addSpacing: PropTypes.bool,
};

CardPreview.defaultProps = {
  addSpacing: true,
  index: '',
  commentIdToUpdate: '',
  commentActions: []
}

export default CardPreview;
